import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
@Component({
  selector: 'app-sentiment-index',
  templateUrl: './sentiment-index.component.html',
  styleUrls: ['./sentiment-index.component.scss']
})
export class SentimentIndex implements OnInit {

  @Input() dataReport: any
  title_report = 'Tổng Thảo Luận Và Xu Hướng Thảo Luận';


  public barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      labels: {
        render: 'value',
        fontColor: 'black',
        precision: 2,
        arc: true,
        fontSize: 13,
        fontStyle: 'bold'
      }
    }
  };
  public barChartOption2 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        precision: 1,
        arc: true,
        fontSize: 13,
        fontStyle: 'bold'
      }
    }
  };
  public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Tích Cực' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Tiêu Cực' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Trung Tính' }
  ];
  public barChartColors: Color[] = [
    { backgroundColor: '#00b0f0' },
    { backgroundColor: '#c10e45' }
  ]

  constructor() {

  }

  ngOnInit(): void {
  };
  async ngOnChanges(changes: SimpleChanges) {    
    if (this.dataReport && this.dataReport.data) {
      console.log(this.dataReport.data);
      await this.mappingData()
     }
  }

   checkSentiment(item,key) {
    return item.key === key;
  }
  async mappingData() {
    this.barChartLabels = [];
    
    this.barChartData = [
      { data: [], label: 'Tích Cực' },
      { data: [], label: 'Tiêu Cực' },
      { data: [], label: 'Trung Tính' }
    ];
    setTimeout(() => {
      for( var _key  in this.dataReport.data.list) {
        this.barChartLabels.push(_key);
        let sentimentList = this.dataReport.data.list[_key].statistic.sentiment.buckets;
        
        let posCount = sentimentList.find(element => {return element.key == 'pos'}) ;
        let negCount = sentimentList.find(element => {return element.key == 'neg'});
        let neuCount = sentimentList.find(element => {return element.key == 'neu'});
  
        this.barChartData[0].data.push(posCount ? (posCount.doc_count ?  posCount.doc_count :  0) : 0);
        this.barChartData[1].data.push(negCount ? (negCount.doc_count ?  negCount.doc_count :  0) : 0);
        this.barChartData[2].data.push(neuCount ? (neuCount.doc_count ? neuCount.doc_count : 0) : 0);      
      }
    }, 0);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/sentiment-index/sentiment-index.component.ts